/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'

import { useFiltersV2 } from '../../contexts/FiltersContextV2'
import clearInput from '../../utils/clear-input'

const useInputFilter = (inputElementsIds: string[]) => {
  const { resetFilters } = useFiltersV2()

  useEffect(() => {
    if (!!resetFilters) {
      inputElementsIds.forEach((elementId: string) => clearInput(elementId))
    }
  }, [resetFilters])
}

export default useInputFilter
